module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_kaicho-6f7260d219082af51526d7f06440ed87.jpg";